import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

import { ApplicationInsightsService } from 'src/app/services/application-insights/application-insights.service';


@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  constructor(private readonly applicationInsightsService: ApplicationInsightsService) {}

  public intercept = (request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> => {
    let lastResponse: HttpEvent<unknown>;
    let error: HttpErrorResponse;

    return next.handle(request).pipe(
      tap((response: HttpEvent<unknown>) => {
        lastResponse = response;
      }),
      catchError((err: HttpErrorResponse) => {
        error = err;
        this.applicationInsightsService.logApiError(error);
        return throwError(err);
      }),
      finalize(() => {
        if (lastResponse.type === HttpEventType.Sent && !error) {
          this.applicationInsightsService.logError(new Error(`Request canceled ${request.url}`));
        }
      })
    );
  };
}
